import Prasad_Alapati from "../assets/images/Prasad_Alapati.png";
import Anand_Allolankandy from "../assets/images/Anand_Allolankandy.png";
import Michael_C_Kiely from "../assets/images/Michael_C_Kiely.png";
import rajesh_adapa from "../assets/images/rajesh_adapa.png";
import swaran from "../assets/images/swaran.png";
import manasa from "../assets/images/manasa.png";
import soumya from "../assets/images/soumya.png";
import navin from "../assets/images/navin.png";
import rangaraj from "../assets/images/rangaraj.png";
import career_icon_1 from "../assets/images/career_icon_1.svg";
import career_icon_2 from "../assets/images/career_icon_2.svg";
import career_icon_3 from "../assets/images/career_icon_3.svg";
import career_icon_4 from "../assets/images/career_icon_4.svg";
import diwali from "../assets/images/diwali.jpg";
import onam from "../assets/images/onam.jpg";
import partner_1 from "../assets/images/logo/aws-partner.png";
import partner_3 from "../assets/images/partner_3.png";
import partner_4 from "../assets/images/partner_4.png";
import partner_7 from "../assets/images/partner_7.png";
import partner_8 from "../assets/images/partner_8.png";
import partner_10 from "../assets/images/partner_10.svg";
import our_community from "../assets/images/our_community.jpg";
import our_aws_competencies_img from "../assets/images/our_aws_competencies_img.jpg";
import medical from "../assets/images/medical.png";
import dental from "../assets/images/dental.png";
import vision from "../assets/images/vision.png";
import direct_deposit from "../assets/images/direct_deposit.png";
import paid from "../assets/images/paid.png";
import google from "../assets/images/logo/google.png";
import microsoft from "../assets/images/logo/microsoft.png";

export const ABOUT_US_READ = [
  {
    img: our_community,
    title: "Our Community",
    link: "/our-community",
  },
  {
    img: our_aws_competencies_img,
    title: "Our AWS Competencies",
    link: "/our-partners",
  },
];

export const WHY_JOIN = [
  {
    img: career_icon_1,
    title: "Continuous Learning",
    desc: "Continuous learning and personal development is an essential part of working life. We work towards developing your technical skills and strategic thinking.",
    bg: "#425CE0",
  },
  {
    img: career_icon_2,
    title: "Work-life Balance",
    desc: "We greatly appreciate all the hard work you are putting in to take the organization towards desired business results. We offer an environment where everyone can find a healthy work-life balance.",
    bg: "#684AEE",
  },
  {
    img: career_icon_3,
    title: "Reward and Recognition",
    desc: "Recognition has always been a cornerstone of our culture. Employee recognition helps foster engagement, increases productivity, and reduces tension in the workplace.",
    bg: "#34CCEA",
  },
  {
    img: career_icon_4,
    title: "Fun at work",
    desc: "Fun at work is a key element of employee happiness. Our fun activities on the campus will help you take that much-needed break from work.",
    bg: "#318FE8",
  },
];

export const CAREER_IMG_CAROUSEL = [
  {
    img: diwali, // Update with actual path of your images
    name: "Diwali Celebration",
  },
  {
    img: onam, // Update with actual path of your images
    name: "Onam Celebration",
  },
];

export const CAREER_CAROUSEL = [
  {
    img: manasa,
    name: "Manasa B",
    designation: "Lead UI/UX Designer",
    desc: "I’m excited to share my experience and feedback as I mark the completion of my three-year journey at Idexcel. The company actively supports individuals eager to grow professionally, providing the resources and opportunities needed to thrive and advance in their careers. I’m proud to be part of this valuable product and an incredibly energetic team. I will continue to bring the same enthusiasm and drive to foster positive change as we move forward.",
  },
  {
    img: swaran,
    name: "Swaran Joji",
    designation: "Technical Project Manager",
    desc: "I joined Idexcel 2 years ago,  just as the effects of covid was weaking. It was very interesting to get back to office after WFH. Working at Idexcel has been a very pleasant experience so far and I am happy to take part in solving some complex challenges. I am able to apply the learnings I have had from previous companies and I am gaining new experiences here. I hope that the work I do will have a lasting impact to the company and the people I work with.",
  },
  {
    img: rangaraj,
    name: "Rangaraj Shanmugam",
    designation: "Module Lead",
    desc: "Over the past Four years in Idexcel, I've embarked on a transformative journey of professional growth and personal development. Each day presented new challenges, which I approached with enthusiasm, leveraging my skills and expertise to overcome hurdles and achieve milestones. Through mentorship programs and continuous learning initiatives, I've expanded my knowledge base, staying abreast of industry trends and best practices. Reflecting on the past four years, I'm proud of the contributions I've made and the growth I've achieved, both professionally and personally.",
  },
  {
    img: navin,
    name: "Naviin Bathulaa",
    designation: "Lead Recruiter",
    desc: "I have been associated with Idexcel for the past 14 years, and it has been a marvelous experience. The management is very cordial, supportive, and values its employees. The work-life balance is excellent. It’s peerless to be a part of such an organization!",
  },
  {
    img: soumya,
    name: "Soumya S Tuppad",
    designation: "Test Engineer",
    desc: "I want to express my deep appreciation to Idexcel Technologies for the incredible opportunity to be part of this team. Transitioning from a Non-IT background into the IT field has been a rewarding challenge, and the unwavering support I've received has been instrumental in my growth. A special thanks goes out to the Cync ABL team for their constant encouragement and guidance, which have played a pivotal role in my development. Your support has truly made a difference in my journey here, and for that, I am sincerely grateful. Thank you to everyone at Idexcel for being an essential part of my experience and growth.",
  },
];

export const WE_CARE = [
  {
    img: medical,
    title: "Medical",
    desc: "Medical coverage is provided by Blue Cross Blue Shield (BCBS). Our plan includes both an HMO (subject to geographical limits) and a PPO option. Additionally, a prescription drug plan is included as well.",
  },
  {
    img: dental,
    title: "Dental",
    desc: "Dental coverage provides for preventative, basic, and major services. You can choose from the dentist of your choice and our dental insurance provider is Anthem.",
  },
  {
    img: vision,
    title: "Vision",
    desc: "Vision care is provided by Blue Cross Blue Shield (BCBS) and designed to provide a basic eye care program including coverage for eye exam, lenses and frames.",
  },
];

export const PLAN401 = [
  {
    img: direct_deposit,
    title: "Direct Deposit",
    desc: "At Idexcel, you are eligible to join our 401(k) plan immediately and save for your retirement using pre-tax dollars.",
  },
  {
    img: paid,
    title: "Paid Time Off",
    desc: "Idexcel’s salaried employees receive paid time off for vacation, holidays and personal sick days.",
  },
];

export const jobData = [
  {
    job_role: "Database Developer",
    location: "Bengaluru",
    link: "/database-developer",
  },
  {
    job_role: "Data Scientist",
    location: "Bengaluru",
    link: "/data-scientist",
  },
  {
    job_role: "AWS Cloud Engineer",
    location: "Bengaluru",
    link: "/aws-cloud-engineer",
  },
  {
    job_role: "Full Stack Developer",
    location: "Bengaluru",
    link: "/full-stack-developer",
  },
  {
    job_role: "NodeJS Developer",
    location: "Bengaluru",
    link: "/nodejs-developer",
  },
  {
    job_role: "Java Micro-Service Developers (5-7 years of experience)",
    location: "Bengaluru",
    link: "/java-micro-service-developers",
  },
  {
    job_role: "Data Engineer",
    location: "Bengaluru",
    link: "/data-engineer",
  },
  {
    job_role: "Principal AWS Data Solutions Architect",
    location: "Bengaluru",
    link: "/principal-aws-data-solutions-architect",
  },
  {
    job_role: "Loan SME Business Analyst",
    location: "Bengaluru",
    link: "/loan-sme-business-analyst",
  },
];

export const partnerData = [
  {
    id: 1,
    img: partner_1,
  },
  {
    id: 7,
    img: google,
  },
  {
    id: 8,
    img: microsoft,
  },
  // {
  //   id: 2,
  //   img: partner_3,
  // },

  // {
  //   id: 3,
  //   img: partner_4,
  // },
  {
    id: 4,
    img: partner_7,
  },
  // {
  //   id: 5,
  //   img: partner_8,
  // },
  {
    id: 6,
    img: partner_10,
  },
];

export const OUR_LEADERS = [
  {
    img: Prasad_Alapati,
    name: "Prasad Alapati",
    designation: "CEO & President",
    desc: "Since co-founding Idexcel in 1998, Prasad sets and evolves the strategic direction for the company and its portfolio of offerings. Prasad has over 25 years of experience in the IT services industry, spanning customer relationship management, strategic alliances, and delivery management with a track record of delivering business transformation initiatives for fortune 500 companies and Federal Government agencies. Prior to co-founding Idexcel, Prasad held technology positions at British Telecom, and American Red Cross. Prasad holds a bachelor's degree in Electronics & Telecommunications Engineering from Marathwada University.",
  },
  {
    img: Anand_Allolankandy,
    name: "Allolankandy Anand",
    designation: "VP | Digital Transformation & Strategy",
    desc: "Anand brings more than 22 years of IT industry experience to lead Idexcel's emerging technologies practice and manage the development of new solution offerings. A passionate technology leader with experience in executive vision, innovation, and leadership, Anand specializes in digital transformation practices using advanced AI technologies, Data Analytics, and Cloud. With extensive focus on strategy-building and overseeing the management of partnership initiatives, Anand ensures client roadmaps are developed to result in optimized, innovative solutions that drive successful customer journeys. When he isn't guiding clients as an Idexcel expert, Anand enjoys hiking and outdoor adventures with his family.",
  },
  {
    img: Michael_C_Kiely,
    name: "Michael Kiely",
    designation: "VP | Sales",
    desc: "Michael joined Idexcel in 2007 to help grow the business organically and through acquisitions. With over 28 years of experience across various industries, Michael develops and drives new sales strategies. He and the Idexcel team have successfully grown the company both nationally and internationally with brand name accounts. Prior to joining our team, he founded Euro Systems International Inc. in 1986 to provide information technology consulting and management services to Fortune 100 and 500 companies in the U.S. and U.K. He also managed two successful IPOs on the Alternative Investment Market (AIM) on the London Exchange. When Michael isn’t working on Idexcel growth goals, he enjoys playing tennis, hiking, and travelling.",
  },
  {
    img: rajesh_adapa,
    name: "Venkata Rajesh Krishna Adapa (Rajesh Adapa)",
    designation: "Sr. Technical Architect | Cyber Security Strategy and Architecture",
    desc: "Since joining Idexcel in 2017, Rajesh has been instrumental in driving the company’s cybersecurity strategy and architecture. A Gold Medalist from Jawaharlal Nehru Technological University, Hyderabad, India, he brings 19 years of IT industry experience, with a strong focus on developing enterprise-level security solutions. Rajesh excels at creating robust security frameworks that protect critical digital assets while ensuring compliance with industry standards and regulations. His leadership in aligning technical initiatives with broader business goals ensures that clients are well-prepared to navigate complex security challenges and emerging threats. Known for his innovative approach to security, he has been key in implementing solutions that foster operational excellence and long-term resilience for clients across various industries. Outside of work, Rajesh actively engages in exploring the latest technology trends and contributing to community initiatives focused on cyber awareness.",
  },
];
